import React, { useMemo } from 'react';
import { Form } from 'react-final-form';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { FormButtonToolbar, FormContainer } from '@spark/ui-components/components/form/FormElements';
import { formStructure, formSections } from './formConfig';
import DynamicForm from '@spark/ui-components/components/form/DynamicForm';
import ConfirmDeleteModal from '../../../../../UI/Modals/index2';
import { useClienteDetalhes } from '../../../hooks/useClienteDetalhes';

const DetalhesForm = ({
  disabled = false
}) => {
  const {
    dadosRecebidos,
    loading,
    saving,
    deleting,
    modalVisible,
    initialValues,
    handleSubmit,
    handleDelete,
    handleEditar,
    handleVoltar,
    setModalVisible
  } = useClienteDetalhes();
  const sections = useMemo(() => formSections(initialValues), [initialValues]);

  if (loading) {
    return <div style={{
      padding: '20px',
      textAlign: 'center'
    }}>
        <p>⏳ Carregando dados do cliente...</p>
      </div>;
  }

  return <>
      <Form onSubmit={handleSubmit} initialValues={initialValues}>
        {({
        handleSubmit: formHandleSubmit,
        form: {
          reset
        },
        values
      }) => {
        return <FormContainer onSubmit={formHandleSubmit}>
              <DynamicForm structure={formStructure} sections={sections} isViewMode={disabled} />
              <FormButtonToolbar className="mt-5 d-flex justify-content-between align-items-center" style={{
            width: '100%'
          }}>
                <div className="d-flex gap-2">
                  <ButtonWithLoading variant="secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                </div>
                <div className="d-flex gap-2">
                  <ButtonWithLoading variant="success" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="danger" onClick={() => setModalVisible(true)}>
                    Deletar
                  </ButtonWithLoading>
                </div>
              </FormButtonToolbar>
            </FormContainer>;
      }}
      </Form>
      {
      /* Modal de confirmação de exclusão */
    }
      <ConfirmDeleteModal show={modalVisible} onClose={() => setModalVisible(false)} onConfirm={handleDelete} loading={deleting} />
    </>;
};

export default DetalhesForm;
